<div
  class="group relative flex items-center justify-between gap-4 font-montserrat max-[1375px]:items-baseline max-[375px]:flex-col max-[375px]:items-start"
  [class.selected]="isSelected"
>
  <div class="mr-10 max-[375px]:mr-0">
    <h5 class="text-[15px] font-bold leading-tight text-black/50 lg:text-base">
      {{ order.Name || '' }} ({{
        order.Status__c === 'Ready' ? 'Pending' : order.Status__c
      }})
    </h5>
    @if (order.Status__c === 'Pending' || order.Status__c === 'Ready') {
      <div
        class="mt-0.5 overflow-hidden text-ellipsis text-nowrap text-xs text-orange-600 transition-colors duration-200 group-hover:text-yellow-500"
        [ngClass]="{ 'text-yellow-500': isSelected }"
      >
        The order is still in initial processing, not all services may be
        displayed
      </div>
    }
  </div>
  <div
    class="flex min-w-[164px] items-center text-[11px] uppercase text-black/50 max-[767px]:mt-1 lg:text-[12px]"
  >
    Order Date:
    <span class="pl-2.5 font-bold">
      {{ (order.Order_Date__c | date: 'MM/dd/yy') || '---' }}
    </span>
  </div>

  <a
    [routerLink]="order.Id"
    tabindex="-1"
    class="absolute inset-0 z-10 block w-full rounded-xl border-none bg-transparent p-0 md:hidden"
  >
    <div class="order-link opacity-0">View Order</div>
  </a>
</div>
